import { useMemo } from 'react';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { EditTwoTone } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Document } from '@api/Trinium/Endpoints/Document';
import { queueModal } from '@components/Modals/modalSlice';
import { useAppDispatch } from '@reduxStore';

import styles from '@components/DataGrid/Documents/DataGrid.Document.module.css';

/**
 * Edit Document
 */
export default function EditAction() {
	const appDispatch = useAppDispatch();
	const gridApiRef = useGridApiContext();
	const selectedRowsMap = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	const selectedRows = useMemo<Document[]>(() => Array.from(selectedRowsMap.values()) as Document[], [selectedRowsMap]);

	const isDisabled = selectedRows.length !== 1;

	const handleBtnClick = () => {
		appDispatch(
			queueModal({
				Component: 'editDocumentModal',
				Props: {
					document: selectedRows[0]
				}
			})
		);
	};

	return (
		<IconButton
			title='Edit Document'
			disabled={isDisabled}
			className={styles['icon-btn']}
			onClick={handleBtnClick}
		>
			<EditTwoTone fontSize='small' />
		</IconButton>
	);
}
